import {showToastMessage} from "./toast_message";

// The character page uses a regular button; character cards use an overlay styled by aria-pressed
function isRegularButton(btn){
    return btn.classList.contains('btn');
}

export function isCharacterCollected(btn){
    return isRegularButton(btn) ? btn.classList.contains('btn-primary') : btn.getAttribute('aria-pressed') === 'true';
}

export function showCharacterCollect(btn, collected, charName = ''){
    if (isRegularButton(btn)){
        btn.classList.toggle('btn-primary', collected);
        btn.classList.toggle('btn-outline-secondary', !collected);
        btn.innerHTML = collected
            ? `<i class="bi bi-person-check-fill me-2"></i>Collecting`
            : `<i class="bi bi-person me-2"></i>Not Collecting`;
        return;
    }
    btn.setAttribute('aria-pressed', collected);
    btn.setAttribute('aria-label', `${collected ? 'Stop collecting' : 'Collect'} ${charName}`.trim());
    btn.title = collected ? 'Collecting' : 'Collect';
    const icon = btn.querySelector('i');
    if (icon){
        icon.classList.toggle('bi-person-check-fill', collected);
        icon.classList.toggle('bi-person', !collected);
    }
}

export function updateCharacterCollect(btn, charId, charName){
    const newCollected = !isCharacterCollected(btn);

    btn.disabled = true;
    return fetch(`/user/collect/${charId}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                collected: newCollected
            })
        })
        .then(response => {
            if (!response.ok){
                throw new Error(`Error updating collect value for ${charName}`);
            }
            showCharacterCollect(btn, newCollected, charName);
            showToastMessage(newCollected ? `Added ${charName} to collected characters` : `Removed ${charName} from collected characters`);
        })
        .catch((err) => {
            showToastMessage(err.message, "danger");
        })
        .finally(() => {
            btn.disabled = false;
        });
}
